export default {
  setDocuments(state, documents) {
    state.documents = documents;
  }
};
